export var createPrependSubscribableThing = function createPrependSubscribableThing(wrapSubscribeFunction) {
  return function (subscribableThing, prependedValue) {
    return wrapSubscribeFunction(function (observer) {
      observer.next(prependedValue);
      return subscribableThing(observer);
    });
  };
};